<template>
  <div class="settings-layout">
    <div class="settings-container">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingsLayout",
};
</script>

<style lang="scss" scoped>
.settings-layout {
  background: #f5f7fa; /* shared light grey backdrop */
  min-height: 100%; /* account for top nav */
  padding: 24px 0;
}

.settings-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}
</style>
